import { render, staticRenderFns } from "./CreateChannelForm.vue?vue&type=template&id=a5c19d4a&"
import script from "./CreateChannelForm.vue?vue&type=script&lang=js&"
export * from "./CreateChannelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports